import { render, staticRenderFns } from "./FreeResourceManageDetail.vue?vue&type=template&id=6fb2c166&scoped=true"
import script from "./FreeResourceManageDetail.vue?vue&type=script&lang=js"
export * from "./FreeResourceManageDetail.vue?vue&type=script&lang=js"
import style0 from "./FreeResourceManageDetail.vue?vue&type=style&index=0&id=6fb2c166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb2c166",
  null
  
)

export default component.exports